/**
 * 日本語形式の日付文字列をYYYY-MM-DD形式に変換する
 *
 * @param dateString 日本語形式の日付（例: "2024年 12月 15日"）
 * @returns YYYY-MM-DD形式の日付文字列、パース失敗時は空文字
 */
export const parseJapaneseDate = (dateString?: string): string => {
    if (!dateString) return '';

    // すでにYYYY-MM-DD形式の場合はそのまま返す
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        return dateString;
    }

    // "2024年 12月 15日" 形式をパース
    const match = dateString.match(/(\d{4})年\s*(\d{1,2})月\s*(\d{1,2})日/);
    if (!match) return '';

    const year = match[1];
    const month = String(match[2]).padStart(2, '0');
    const day = String(match[3]).padStart(2, '0');

    return `${year}-${month}-${day}`;
};
